import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';

export const formatBoolean = (value: boolean) => {
    if (value) {
        return (
            <b>
                <FontAwesomeIcon
                    className='green-text'
                    icon={faCheck}
                />
            </b>
        );
    } else {
        return (
            <b>
                <FontAwesomeIcon
                    className='red-text'
                    icon={faTimes}
                />
            </b>
        );
    }
};
